import React from 'react';
import { LucideIcon } from 'lucide-react';

export interface QuickAction {
  label: string;
  icon: LucideIcon;
  action: () => void;
}

interface QuickActionPillsProps {
  actions: QuickAction[];
  variant?: 'compact' | 'full';
  className?: string;
}

/**
 * Reusable quick action pills for chat input areas
 * Used in both embedded chat and bottom bar
 */
export const QuickActionPills: React.FC<QuickActionPillsProps> = ({
  actions,
  variant = 'full',
  className = '',
}) => {
  if (variant === 'compact') {
    return (
      <div className={`flex items-center gap-1 ${className}`}>
        {actions.map((action) => (
          <button
            type="button"
            key={action.label}
            onClick={action.action}
            className="group hidden sm:flex items-center gap-1.5 px-2.5 py-1.5 text-[11px] font-medium text-gray-500 bg-white border border-gray-200 rounded-lg hover:border-gray-300 hover:text-gray-700 hover:bg-gray-50 hover:shadow-sm transition-all"
            title={action.label}
          >
            <action.icon className="w-3 h-3 text-gray-400 group-hover:text-gray-500 transition-colors" />
            <span>{action.label}</span>
          </button>
        ))}
      </div>
    );
  }

  return (
    <div data-tour="workflow-buttons" className={`flex flex-wrap gap-1.5 mb-2 ${className}`}>
      {actions.map((action) => (
        <button
          type="button"
          key={action.label}
          onClick={action.action}
          className="group flex items-center gap-1 px-2.5 py-1 text-[11px] font-medium text-gray-500 bg-white border border-gray-200 rounded-full hover:border-gray-300 hover:text-gray-700 hover:bg-gray-50 transition-all"
        >
          <action.icon className="w-3 h-3 text-gray-400 group-hover:text-gray-500 transition-colors" />
          <span>{action.label}</span>
        </button>
      ))}
    </div>
  );
};
